var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110.4,
    height: 151.221,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 151.221,
    opacity: 0,
    width: 110.4,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 79.9805C0 110.742 24.5117 135.303 55.2246 135.303C85.8887 135.303 110.4 110.742 110.4 79.9805C110.4 77.3926 108.545 75.5371 105.908 75.5371C103.369 75.5371 101.758 77.3926 101.758 79.9805C101.758 105.957 81.1035 126.66 55.2246 126.66C29.2969 126.66 8.64258 105.957 8.64258 79.9805C8.64258 54.1504 29.2969 33.5449 55.2246 33.5449C60.6445 33.5449 65.8203 34.082 69.873 35.1074L49.2188 55.7617C48.3398 56.6406 47.9492 57.7148 47.9492 58.8379C47.9492 61.2793 49.8047 63.1348 52.1973 63.1348C53.5156 63.1348 54.541 62.7441 55.3223 61.9141L81.8359 35.1562C82.9102 34.0332 83.3496 32.959 83.3496 31.7383C83.3496 30.5176 82.8613 29.2969 81.8359 28.3203L55.3223 1.31836C54.5898 0.439453 53.5645 0 52.1973 0C49.7559 0 47.9492 1.95312 47.9492 4.39453C47.9492 5.51758 48.3398 6.64062 49.1699 7.51953L67.9199 26.2695C64.3555 25.4883 59.8633 24.9023 55.2246 24.9023C24.5117 24.9023 0 49.3652 0 79.9805Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.0d699ab426ecc2627ae8e55d3e795c44.svg";
export { ForwardRef as ReactComponent };